<template>
  <div class="diseaseList">
    <!-- 开户按钮 -->
    <el-form :inline="true" size="small">
      <el-form-item>
        <el-button
          :loading="downloadLoading"
          style="margin-right: 20px"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
          >导出 Excel（数量/ {{ dataList.length }}条）</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height: 80vh">
      <el-table
        :data="dataList"
        style="width: 100%"
        height="100%"
        border
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-text="正在加载中"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          label="登记时间"
          width="180"
          align="center"
          prop="create_time"
          sortable
        ></el-table-column>
        <el-table-column label="姓名" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手机号"
          width="150"
          align="center"
          prop="phone"
        ></el-table-column>
        <el-table-column label="身份证号码" align="center" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.idCard ? scope.row.idCard : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="公司" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.fair ? scope.row.fair : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="职位" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.position ? scope.row.position : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="城市" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.city ? scope.row.city : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="目的"
          width="150"
          align="center"
          prop="intention"
        ></el-table-column>
        <el-table-column
          label="留言"
          width="150"
          align="center"
          prop="remarks"
        ></el-table-column>
        <el-table-column
          label="设备"
          width="80"
          align="center"
          prop="equipment"
        ></el-table-column>
        <el-table-column label="分享成功次数" align="center">
          <template slot-scope="scope">
            <el-tag
              class="tag"
              type="success"
              v-if="scope.row.shareCount === '查询'"
              @click="handleShareCount(scope.row, scope.$index)"
              >查询</el-tag
            >
            <span v-else>{{ scope.row.shareCount }}</span>
          </template>
        </el-table-column>

        <el-table-column label="是否领取礼品" align="center">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.status_reward === 0"
              >未领取</el-tag
            >
            <el-tag type="success" v-if="scope.row.status_reward === 1"
              >已领取</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleUpdateStatus(scope.row)"
              >标记领取礼物</el-button
            >
            <el-button size="mini" type="danger" @click="deleteBtn(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  selectMini,
  setRewardStatus,
  selectShareRecord,
} from "@/services/supAdmin/teaData/index.js";
// import { createCardnumberList, selectCardnumberList } from "@/services/vipCard";
export default {
  data() {
    return {
      downloadLoading: false,
      dataList: [],
      supplierPhone: "",
      phone: "",
      cardNumber: "",
      loading: false,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: 1 },
        { name: "普通子账号权限", id: 2 },
      ],
      form: {},
      dialogFormVisible: false,
    };
  },
  created() {
    this.select();
  },
  methods: {
    select() {
      this.loading = true;
      // 查询数据
      selectMini().then((res) => {
        console.log(res);
        this.dataList = res.data.map((res) => {
          return {
            ...res,
            shareCount: "查询",
          };
        });
        this.loading = false;
      });
    },
    handleShareCount(row, index) {
      console.log("----------查询------------", row, index);
      // 查询领取状态
      selectShareRecord({ phone: row.phone }).then((res) => {
        console.log(res);
        this.dataList[index].shareCount = res.data.length;
      });
    },
    // 删除
    deleteBtn(row) {
      console.log("----------删除------------", row);
      this.$message.error("暂未开启该权限");
      // this.select();
    },

    handleUpdateStatus(row) {
      this.$confirm("确定修改领取状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          setRewardStatus({ id: row.id }).then((res) => {
            console.log(res);
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("@/utils/vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "时间",
          "姓名",
          "手机号",
          "身份证号",
          "公司",
          "公司",
          "职位",
          "城市",
          "目的",
          "留言",
          "设备",
        ];
        const filterVal = [
          "create_time",
          "name",
          "phone",
          "idCard",
          "fair",
          "fair",
          "position",
          "city",
          "intention",
          "remarks",
          "equipment",
        ];
        const list = this.dataList;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "百度观众数据登记数据下载",
          autoWidth: true, //Optional
          bookType: "xlsx", //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
  },
};
</script>

<style>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
.tag {
  cursor: pointer;
}
</style>
